import React, { useState, Fragment } from 'react';
import { useForm } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import apiService from '../../services/apiServices';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';

export default function AddDepartment() {
  //const classes = useStyles();
  const initialToast = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(initialToast);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const statuses=[{id:1,name:"aktiv"},{id:2,name:"inaktiv"}]

  const onSubmit = (data) => {
      const statusId = data?.Status?.id ?? data?.Status;
      if (statusId !== undefined) {
        data.Status = statusId;
      }
    console.log(data);
    apiService()
      .post('department', data)
      .then((response) => {
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/departmentlist/adddepartment"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Lloji i Departamentit
            </Typography>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Emri i Departamentit"
                    error={errors.Name}
                    control={control}
                    name="Name"
                    register={{ ...register('Name') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Inicialet"
                    error={errors.ShortName}
                    control={control}
                    name="ShortName"
                    register={{ ...register('ShortName') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <SelectController
                    placeholder="Statusi"
                    error={errors.Status}
                    control={control}
                    options={statuses}
                    name="Status"
                    register={{ ...register('Status') }}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
